
import { Bet,GroupedEvent,Selection,InternalGroupedEvent,CalaculationEvent,CalaculationRequest,CalaculationSelection,TicketEventStatus } from '../types';
export const  groupCalculationBetsToEvents = (bets: Bet[], includeClosed:boolean=false ,includeSuspended:boolean=false ): GroupedEvent[] =>{
  const eventsMap = new Map<string, Bet[]>();

  for (const bet of bets) {
    if (!eventsMap.has(bet.eventId)) {
      eventsMap.set(bet.eventId, []);
    }
    eventsMap.get(bet.eventId)!.push(bet);
  }

  const result: GroupedEvent[] = [];

  for (const [eventId, eventBets] of eventsMap.entries()) {
    const hasDirty = eventBets.some(b => b.isDirty);
    if (!hasDirty) continue;

    for (const bet of eventBets) {
      if (bet.isDirty) {
        bet.isDirty = false;
      }
    }
    
    const allClosed = eventBets.every(bet => bet.closed || bet.eventClosed);
    const allSuspended = eventBets.every(bet => bet.suspended || bet.eventSuspended);
    const anyEventClosed = eventBets.some(bet => bet.eventClosed);
    const anyEventSuspended = eventBets.some(bet => bet.eventSuspended);
    if(!includeClosed && allClosed) continue;
    if(!includeSuspended && allSuspended) continue;

    const selections:Selection[] = eventBets
      .filter(bet => !bet.closed && !bet.suspended)
      .map((bet, index) => ({
        BetTypeId: parseInt(bet.id),
        BetTypeName: bet.marketName,
        OddKey: bet.selectionName,
        OddPrice: bet.odds,
        OddLine: bet.line ?? null,
        DisplayOrder: index + 1,
        BetTypeNameTranslated: bet.selectionNameTranslation || bet.marketName,

       
      }));

    result.push({
      EventId: parseInt(eventId),
      Type: 1,
      Selections: selections,
      Closed: allClosed || anyEventClosed,
      Suspended: allSuspended || anyEventSuspended,
      EventName: eventBets[0].eventName,
      EventStatus: eventBets[0].eventStatus || -1,
      Home:eventBets[0].home?eventBets[0].home:'',
      Away:eventBets[0].away?eventBets[0].away:'',
      Seperator:eventBets[0].eventSeperator?eventBets[0].eventSeperator:'',
      FixtureId: eventBets[0].fixtureId?eventBets[0].fixtureId:'',
      EventDate: eventBets[0].date?eventBets[0].date:'',
      TotalOdds: eventBets[0].totalOdds?eventBets[0].totalOdds>-1?eventBets[0].totalOdds:-1:-1,
      EventNameTranslated: eventBets[0].eventNameTranslation || eventBets[0].eventName
    });
  }

  return result;
}
export const getBetsGroups = (bets: Bet[]):Record<string, Bet[]> =>{
  const groupedBets = bets.reduce((acc, bet) => {
    if (!acc[bet.eventId]) {
      acc[bet.eventId] = [];
    }
    acc[bet.eventId].push(bet);
    return acc;
  }, {} as Record<string, Bet[]>);
  return groupedBets;
}

export const buildInternalGroupedEvents = (bets: Bet[]): InternalGroupedEvent[] => {
  const groupedBets = getBetsGroups(bets);

  let result: InternalGroupedEvent[] = [];

  for (const [eventId, eventBets] of Object.entries(groupedBets)) {
    const allClosed = eventBets.every(b => b.closed || b.eventClosed);
    const allSuspended = eventBets.every(b => b.suspended || b.eventSuspended);
    const anyEventClosed = eventBets.some(b => b.eventClosed);
    const anyEventSuspended = eventBets.some(b => b.eventSuspended);
    const eventStatus = (eventBets: Bet[]): TicketEventStatus | undefined => {
      const bet = eventBets.find(b => b.eventStatus !== undefined && b.eventStatus > -1);
      return bet?.eventStatus;
    };
    result.push({
      EventId: parseInt(eventId),
      Type: 1,
      Selections: eventBets,
      Closed: allClosed || anyEventClosed,
      Suspended: allSuspended || anyEventSuspended,
      EventName: eventBets.length>0?eventBets[0].eventName:'',
      EventStatus: eventStatus(eventBets) || -1,
      Home:eventBets[0].home?eventBets[0].home:'',
      Away:eventBets[0].away?eventBets[0].away:'',
      Seperator:eventBets[0].eventSeperator?eventBets[0].eventSeperator:'',
      FixtureId: eventBets[0].fixtureId?eventBets[0].fixtureId:'',
      EventDate: eventBets[0].date?eventBets[0].date:'',
      TotalOdds: eventBets[0].totalOdds?eventBets[0].totalOdds>-1?eventBets[0].totalOdds:-1:-1,
      EventNameTranslated: eventBets[0].eventNameTranslation || eventBets[0].eventName
    });
  }
  result = result.filter(event => event.Selections.length > 1);
  return result;
}

export const isClosedOrSuspended=(group:InternalGroupedEvent):boolean=>{
    return group.Closed || group.Suspended;    
}

export const buildCalculationRequest = (bets: Bet[]): CalaculationRequest => {
  
  const validBets = bets.filter(bet =>
    !bet.closed &&
    !bet.suspended &&
    !bet.eventClosed &&
    !bet.eventSuspended
  );
 
  const groupedBets = getBetsGroups(validBets);
  
  const result: CalaculationEvent[] = [];

  for (const [eventId, eventBets] of Object.entries(groupedBets)) {
    const dirtyBets = eventBets.filter(bet => bet.isDirty);
    if (dirtyBets.length === 0) continue;
    const uniqueBetTypes = new Set(eventBets.map(bet => `${bet.marketName}-${bet.line ?? ''}`));
    if (uniqueBetTypes.size <= 1) continue;

    result.push({
      EventId: parseInt(eventId),
      CalculationType: 2,
      Selections: mapBetsToCalculationSelections(eventBets),
    });
  }

  return { BetBuilderEvents: result };
};


export const mapBetsToCalculationSelections = (bets: Bet[]): CalaculationSelection[]=> {
  return bets.map((bet, index) => ({
    BetTypeId: parseInt(bet.id ?? '0'), 
    BetTypeName: bet.marketName,
    OddKey: bet.selectionName,            
    OddPrice: bet.odds,
    DisplayOrder: index,
    OddLine:bet.line                 
  }));
}

export function getEnumKeyByValue<T extends Record<string, number | string>>(
  enumObj: T,
  value: T[keyof T]
): keyof T | undefined {
  return (Object.keys(enumObj) as Array<keyof T>).find(
    (key) => enumObj[key] === value
  );
}

export function generateUniqueId(prefix = 'id') {
  const timestamp = Date.now().toString(36);           
  const randomPart = Math.random().toString(36).substr(2, 6);
  return `${prefix}_${timestamp}_${randomPart}`;
}

export const removedItems = (
    totalBets: Bet[],
    toRemove: Bet | Bet[]
  ): Bet[] => {
    const removeList = Array.isArray(toRemove) ? toRemove : [toRemove];
    const removeKeys = new Set(removeList.map(b => `${b.id}|${b.eventId}`));
    const grouped: Record<string, Bet[]> = {};
    for (const bet of totalBets) {
      if (!grouped[bet.eventId]) grouped[bet.eventId] = [];
      grouped[bet.eventId].push(bet);
    }

    const result: Bet[] = [];

    for (const [eventId, bets] of Object.entries(grouped)) {
      const betsToRemove = bets.filter(b => removeKeys.has(`${b.id}|${b.eventId}`));
      const remainingBets = bets.filter(b => !removeKeys.has(`${b.id}|${b.eventId}`));

      if (remainingBets.length === 0) {
        betsToRemove[0].autoRemoved=true;
        result.push(...betsToRemove);
      } else if (betsToRemove.length > 0 && (remainingBets.length === 1)) {
        remainingBets[0].autoRemoved = true;
        result.push(...bets);
      }
      else if(betsToRemove.length === 2 &&  remainingBets.length === 2){
        remainingBets[0].autoRemoved = true;
        result.push(...bets);
      
      } else {
        result.push(...betsToRemove);
      }
    }

    return result;
  }
export function applyObjetcDefaults<T>(obj: T, defaults: Partial<T>): T {
  return {
    ...defaults,
    ...obj,
  };
}
export function applyPropertyDefault<T, K extends keyof T>(obj: T, key: K, defaultValue: T[K]): void {
  if (obj[key] === undefined) {
    obj[key] = defaultValue;
  }
}
export const formatIsoToCustomDate = (isoString: string): string => {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
};